const PrescriptionDownload = ({ checkUp }) => {
  console.log("CheckUp data in PrescriptionDownload:", checkUp);
  console.log(
    "User Details for owner prescription:",
    checkUp?.pet?.ownerId?.userDetails
  );
  // Format date and time
  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return {
      date: date.toLocaleDateString("en-IN", {
        year: "numeric",
        month: "long",
        day: "numeric",
      }),
      time: date.toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      }),
    };
  };

  // Generate prescription HTML document
  const generatePrescriptionHTML = () => {
    const dateTime = formatDateTime(checkUp.createdAt);

    return `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Prescription - ${checkUp.pet?.name || "Pet"} - ${
      dateTime.date
    }</title>
    <style>
  @page {
    size: A4;
    margin: 10mm;
  }
  body {
    font-family: 'Arial', sans-serif;
    font-size: 11px;
    line-height: 1.3;
    color: #333;
    background: white;
    margin: 0;
    padding: 0;
  }
  .prescription-container {
    width: 190mm; /* fit inside A4 margins */
    min-height: 277mm;
    margin: auto;
    background: white;
    padding: 10mm;
    box-sizing: border-box;
  }
  /* Compact header */
  .header {
    text-align: center;
    border-bottom: 2px solid #2563eb;
    padding: 8px 0;
    margin-bottom: 10px;
    background: linear-gradient(135deg, #2563eb, #1d4ed8);
   
    border-radius: 4px;
  }
  .header h1 {
    font-size: 18px;
    margin: 0;
  }
  .clinic-details {
    font-size: 9px;
    line-height: 1.2;
    color:  #4b5563;
  }
  .prescription-title {
    font-size: 14px;
    font-weight: bold;
    background: #f3f4f6;
    text-align: center;
    margin: 8px 0;
    padding: 6px;
    border-radius: 4px;
  }
  .info-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin-bottom: 10px;
  }
  .info-section {
    background: #f9fafb;
    padding: 6px;
    border-radius: 4px;
    border-left: 3px solid #2563eb;
  }
  .info-section h3 {
    font-size: 11px;
    margin-bottom: 4px;
  }
  .info-row {
    display: flex;
    margin-bottom: 3px;
    font-size: 10px;
  }
  .info-label {
    font-weight: bold;
    min-width: 65px;
  }
  .medical-section {
    margin: 8px 0;
    padding: 8px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
  }
  .medical-section h3 {
    font-size: 12px;
    margin-bottom: 4px;
  }
  .complaint-text,
  .diagnosis-text,
  .treatment-text {
    font-size: 10px;
    line-height: 1.3;
    padding: 6px;
    background: white;
    border: 1px solid #ddd;
    border-radius: 3px;
  }
  .prescription-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 10px;
  }
  .prescription-table th,
  .prescription-table td {
    border: 1px solid #ddd;
    padding: 4px;
    text-align: left;
  }
  .vital-signs {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    gap: 6px;
  }
  .vital-item {
    border: 1px solid #ddd;
    padding: 6px;
    text-align: center;
    font-size: 10px;
  }
  .notes-section {
    background: #fef3c7;
    border: 1px solid #f59e0b;
    font-size: 10px;
    padding: 6px;
    border-radius: 4px;
  }
  .signature-section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-top: 12px;
  }
  .signature-box {
    text-align: center;
    padding-top: 20px;
    border-top: 1px solid #333;
    font-size: 10px;
  }
  .footer {
    margin-top: 12px;
    font-size: 9px;
    text-align: center;
    color: #555;
  }
  .watermark {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-45deg);
    font-size: 36px;
    color: rgba(0,0,0,0.05);
    z-index: -1;
  }
  @media print {
    .prescription-container {
      box-shadow: none;
      margin: 0;
      padding: 0;
    }
    .no-print {
      display: none !important;
    }
    body {
      background: white;
    }
  }
</style>
</head>
<body>
    <div class="watermark">PRESCRIPTION</div>
    
    <div class="prescription-container">
        <!-- Header -->
        <div class="header">
            
            <h1>🤖 VetSense AI Health Analysis Report </h1>
            <p>Advanced Pet Health Assessment</p>
           
        </div>

        <!-- Prescription Title -->
        <div class="prescription-title">
            MEDICAL PRESCRIPTION & TREATMENT RECORD
        </div>

        <!-- Patient & Visit Information -->
        <div class="info-grid">
            <!-- Pet Information -->
            <div class="info-section">
                <h3>🐾 Pet Information</h3>
                <div class="info-row">
                    <span class="info-label">Name:</span>
                    <span class="info-value">${
                      checkUp.pet?.name || "N/A"
                    }</span>
                </div>
                <div class="info-row">
                    <span class="info-label">Species:</span>
                    <span class="info-value">${
                      checkUp.pet?.species || "N/A"
                    }</span>
                </div>
                <div class="info-row">
                    <span class="info-label">Breed:</span>
                    <span class="info-value">${
                      checkUp.pet?.breed || "N/A"
                    }</span>
                </div>
                <div class="info-row">
                    <span class="info-label">Age:</span>
                    <span class="info-value">${checkUp.pet?.age || "N/A"}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">Weight:</span>
                    <span class="info-value">${
                      checkUp.pet?.weight || "N/A"
                    } kg</span>
                </div>
                <div class="info-row">
                    <span class="info-label">Gender:</span>
                    <span class="info-value">${
                      checkUp.pet?.gender || "N/A"
                    }</span>
                </div>
            </div>

            <!-- Owner & Visit Information -->
            <div class="info-section">
                <h3>👤 Owner & Visit Details</h3>
                <div class="info-row">
                    <span class="info-label">Owner:</span>
                    <span class="info-value">${
                      checkUp.pet?.ownerId?.userDetails?.name || "N/A"
                    }</span>
                    
                </div>
                <div class="info-row">
                    <span class="info-label">Phone:</span>
                    <span class="info-value">${
                      checkUp.pet?.ownerId?.userDetails?.userdetails?.contact
                        ?.mobile || "N/A"
                    }</span>
                </div>
                <div class="info-row">
                    <span class="info-label">Visit Date:</span>
                    <span class="info-value">${dateTime.date}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">Visit Time:</span>
                    <span class="info-value">${dateTime.time}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">Visit #:</span>
                    <span class="info-value">${
                      checkUp.visitNumber || "N/A"
                    }</span>
                </div>
                <div class="info-row">
                    <span class="info-label">Status:</span>
                    <span class="info-value">
                        <span class="status-badge ${
                          checkUp.status === "completed"
                            ? "status-completed"
                            : checkUp.status === "in-progress"
                            ? "status-in-progress"
                            : "status-pending"
                        }">
                            ${checkUp.status || "Unknown"}
                        </span>
                    </span>
                </div>
            </div>
        </div>

        <!-- Doctor Information -->
        <div class="info-section" style="margin-bottom: 25px;">
            <h3>👨‍⚕️ Attending Veterinarian</h3>
            <div class="info-row">
                <span class="info-label">Doctor:</span>
                <span class="info-value">Dr. ${
                  checkUp.doctor?.name || "N/A"
                }</span>
            </div>
            <div class="info-row">
                <span class="info-label">Specialization:</span>
                <span class="info-value">${
                  checkUp.doctor?.specialization || "General Practice"
                }</span>
            </div>
            <div class="info-row">
                <span class="info-label">License:</span>
                <span class="info-value">${
                  checkUp.doctor?.licenseNumber || "N/A"
                }</span>
            </div>
            <div class="info-row">
                <span class="info-label">Contact:</span>
                <span class="info-value">${
                  checkUp.doctor?.phone || "N/A"
                }</span>
            </div>
        </div>

        <!-- Chief Complaint -->
        <div class="medical-section">
            <h3>🔍 Chief Complaint</h3>
            <div class="complaint-text">
                ${checkUp.chiefComplaint || "No specific complaint mentioned."}
            </div>
        </div>

        <!-- Vital Signs -->
        ${
          checkUp.vitalSigns
            ? `
        <div class="medical-section">
            <h3>📊 Vital Signs</h3>
            <div class="vital-signs">
                ${
                  checkUp.vitalSigns.temperature
                    ? `
                <div class="vital-item">
                    <div class="vital-label">Temperature</div>
                    <div class="vital-value">${checkUp.vitalSigns.temperature}°F</div>
                </div>`
                    : ""
                }
                ${
                  checkUp.vitalSigns.heartRate
                    ? `
                <div class="vital-item">
                    <div class="vital-label">Heart Rate</div>
                    <div class="vital-value">${checkUp.vitalSigns.heartRate} bpm</div>
                </div>`
                    : ""
                }
                ${
                  checkUp.vitalSigns.respiratoryRate
                    ? `
                <div class="vital-item">
                    <div class="vital-label">Respiratory Rate</div>
                    <div class="vital-value">${checkUp.vitalSigns.respiratoryRate} /min</div>
                </div>`
                    : ""
                }
                ${
                  checkUp.vitalSigns.weight
                    ? `
                <div class="vital-item">
                    <div class="vital-label">Weight</div>
                    <div class="vital-value">${checkUp.vitalSigns.weight} kg</div>
                </div>`
                    : ""
                }
            </div>
        </div>`
            : ""
        }

        <!-- Diagnosis -->
        <div class="medical-section">
            <h3>🩺 Diagnosis</h3>
            <div class="diagnosis-text">
                <strong>Primary Diagnosis:</strong> ${
                  checkUp.diagnosis?.primary || "Not specified"
                }<br><br>
                ${
                  checkUp.diagnosis?.secondary
                    ? `<strong>Secondary Diagnosis:</strong> ${checkUp.diagnosis.secondary}<br><br>`
                    : ""
                }
                ${
                  checkUp.diagnosis?.notes
                    ? `<strong>Clinical Notes:</strong> ${checkUp.diagnosis.notes}`
                    : ""
                }
            </div>
        </div>

        <!-- Prescription Table -->
        ${
          checkUp.prescription && checkUp.prescription.length > 0
            ? `
        <div class="medical-section">
            <h3>💊 Prescription</h3>
            <table class="prescription-table">
                <thead>
                    <tr>
                        <th style="width: 25%;">Medicine Name</th>
                        <th style="width: 15%;">Dosage</th>
                        <th style="width: 15%;">Frequency</th>
                        <th style="width: 15%;">Duration</th>
                        <th style="width: 30%;">Instructions</th>
                    </tr>
                </thead>
                <tbody>
                    ${checkUp.prescription
                      .map(
                        (med) => `
                        <tr>
                            <td><strong>${med.medication || "N/A"}</strong></td>
                            <td>${med.dosage || "N/A"}</td>
                            <td>${med.frequency || "N/A"}</td>
                            <td>${med.duration || "N/A"}</td>
                            <td>${med.instructions || "As directed"}</td>
                        </tr>
                    `
                      )
                      .join("")}
                </tbody>
            </table>
        </div>`
            : ""
        }

        <!-- Treatment Plan -->
        ${
          checkUp.treatmentPlan
            ? `
        <div class="medical-section">
            <h3>🎯 Treatment Plan</h3>
            <div class="treatment-text">
                ${checkUp.treatmentPlan}
            </div>
        </div>`
            : ""
        }

        <!-- Follow-up Instructions -->
        ${
          checkUp.followUpInstructions
            ? `
        <div class="notes-section">
            <div class="notes-title">⚠️ Follow-up Instructions & Important Notes</div>
            <div class="notes-text">
                ${checkUp.followUpInstructions}
            </div>
        </div>`
            : ""
        }

        <!-- Billing Information -->
        ${
          checkUp.billing
            ? `
        <div class="medical-section">
            <h3>💰 Billing Summary</h3>
            <div class="info-grid">
                <div>
                    <div class="info-row">
                        <span class="info-label">Consultation:</span>
                        <span class="info-value">₹${
                          checkUp.billing.consultationFee?.toLocaleString() ||
                          "0"
                        }</span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">Medicines:</span>
                        <span class="info-value">₹${
                          checkUp.billing.medicineCharges?.toLocaleString() ||
                          "0"
                        }</span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">Other Charges:</span>
                        <span class="info-value">₹${
                          checkUp.billing.otherCharges?.toLocaleString() || "0"
                        }</span>
                    </div>
                </div>
                <div>
                    <div class="info-row">
                        <span class="info-label"><strong>Total Amount:</strong></span>
                        <span class="info-value"><strong>₹${
                          checkUp.billing.totalAmount?.toLocaleString() || "0"
                        }</strong></span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">Payment Method:</span>
                        <span class="info-value">${
                          checkUp.billing.paymentMethod || "N/A"
                        }</span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">Payment Status:</span>
                        <span class="info-value">${
                          checkUp.billing.paymentStatus || "Pending"
                        }</span>
                    </div>
                </div>
            </div>
        </div>`
            : ""
        }

        <!-- Footer -->
        <div class="footer">
            <div style="text-align: center; margin-bottom: 20px; font-size: 11px; color: #6b7280;">
                This prescription is computer generated and contains confidential medical information.
                <br>Please follow the prescribed medication and dosage strictly. Contact the clinic for any queries.
            </div>

            <!-- Signature Section -->
            <div class="signature-section">
                <div class="signature-box">
                    <div class="signature-label">Patient/Owner Signature</div>
                    <div style="font-size: 10px; color: #6b7280; margin-top: 5px;">
                        ${
                          checkUp.pet?.ownerId?.userDetails?.name ||
                          "Owner Name"
                        }
                    </div>
                </div>
                <div class="signature-box">
                    <div class="signature-label">Doctor Signature</div>
                    <div style="font-size: 10px; color: #6b7280; margin-top: 5px;">
                        Dr. ${checkUp.doctor?.name || "Doctor Name"}
                    </div>
                </div>
            </div>

            <!-- Footer Info -->
            <div style="text-align: center; margin-top: 20px; padding-top: 15px; border-top: 1px solid #e5e7eb; font-size: 10px; color: #6b7280;">
                Generated on: ${new Date().toLocaleString("en-IN")} | 
                Prescription ID: ${checkUp._id || "N/A"} | 
                Appointment ID: ${
                  checkUp.appointment?._id || checkUp.appointment || "N/A"
                }
                <br><br>
                <strong>Emergency Contact:</strong> +91-9876543210 (24/7 Available)
            </div>
        </div>
    </div>
</body>
</html>`;
  };

  // Handle download prescription
  const handleDownloadPrescription = () => {
    try {
      const htmlContent = generatePrescriptionHTML();

      // Create a new window/tab
      const printWindow = window.open("", "_blank");

      if (!printWindow) {
        alert(
          "Please allow popups for this website to download the prescription."
        );
        return;
      }

      // Write the HTML content to the new window
      printWindow.document.write(htmlContent);
      printWindow.document.close();

      // Wait for content to load, then trigger print dialog
      printWindow.onload = () => {
        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
        }, 500);
      };

      console.log(
        "Prescription generated successfully for:",
        checkUp.pet?.name
      );
    } catch (error) {
      console.error("Error generating prescription:", error);
      alert("Failed to generate prescription. Please try again.");
    }
  };

  // Generate AI Health Analysis HTML (compact single page)
  const generateAIAnalysisHTML = () => {
    const dateTime = formatDateTime(checkUp.createdAt);

    return `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>VetSense AI Health Analysis - ${checkUp.pet?.name || "Pet"}</title>
    <style>
        @page {
            size: A4;
            margin: 15mm;
        }
        
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }
        
        body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            font-size: 11px;
            line-height: 1.3;
            color: #333;
            background: #f8f9fa;
        }
        
        .container {
            max-width: 210mm;
            margin: 0 auto;
            background: white;
            padding: 15px;
            height: 100vh;
            overflow: hidden;
        }
        
        .header {
            background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
            color: white;
            text-align: center;
            padding: 12px;
            margin-bottom: 15px;
            border-radius: 8px;
        }
        
        .header h1 {
            font-size: 18px;
            font-weight: 700;
            margin: 0;
        }
        
        .priority-badge {
            display: inline-block;
            padding: 4px 12px;
            border-radius: 15px;
            font-size: 9px;
            font-weight: 600;
            text-transform: uppercase;
            margin: 8px 0;
        }
        
        .high-priority {
            background: #ef4444;
            color: white;
        }
        
        .medium-priority {
            background: #f59e0b;
            color: white;
        }
        
        .low-priority {
            background: #10b981;
            color: white;
        }
        
        .confidence {
            float: right;
            font-size: 9px;
            color: #6b7280;
            margin-top: 5px;
        }
        
        .pet-info {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            gap: 20px;
            margin-bottom: 12px;
            font-size: 10px;
        }
        
        .pet-info div {
            display: flex;
            flex-direction: column;
        }
        
        .pet-info strong {
            color: #374151;
            margin-bottom: 2px;
        }
        
        .symptoms-section {
            background: #f3f4f6;
            padding: 10px;
            border-radius: 6px;
            margin-bottom: 12px;
            border-left: 4px solid #6b7280;
        }
        
        .symptoms-section h3 {
            font-size: 11px;
            color: #374151;
            margin-bottom: 5px;
            display: flex;
            align-items: center;
        }
        
        .checkbox {
            width: 12px;
            height: 12px;
            margin-right: 8px;
            border: 2px solid #d1d5db;
            border-radius: 2px;
            background: white;
        }
        
        .assessment-section {
            background: white;
            border: 1px solid #e5e7eb;
            border-radius: 6px;
            padding: 10px;
            margin-bottom: 12px;
        }
        
        .assessment-section h3 {
            font-size: 12px;
            font-weight: 600;
            color: #1f2937;
            margin-bottom: 8px;
        }
        
        .key-findings {
            background: #dbeafe;
            border-left: 4px solid #3b82f6;
            padding: 8px;
            margin-bottom: 10px;
            border-radius: 4px;
        }
        
        .key-findings h4 {
            font-size: 11px;
            font-weight: 600;
            color: #1e40af;
            margin-bottom: 5px;
            display: flex;
            align-items: center;
        }
        
        .key-findings ul {
            list-style: none;
            padding: 0;
            font-size: 10px;
        }
        
        .key-findings li {
            margin-bottom: 3px;
            padding-left: 12px;
            position: relative;
        }
        
        .key-findings li:before {
            content: "•";
            color: #3b82f6;
            position: absolute;
            left: 0;
        }
        
        .recommendations-grid {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            gap: 10px;
            margin-bottom: 12px;
        }
        
        .recommendation-card {
            padding: 8px;
            border-radius: 6px;
            font-size: 9px;
        }
        
        .immediate {
            background: #fef2f2;
            border-left: 4px solid #ef4444;
        }
        
        .short-term {
            background: #fefce8;
            border-left: 4px solid #f59e0b;
        }
        
        .long-term {
            background: #f0f9ff;
            border-left: 4px solid #3b82f6;
        }
        
        .recommendation-card h4 {
            font-size: 10px;
            font-weight: 600;
            margin-bottom: 5px;
            display: flex;
            align-items: center;
        }
        
        .recommendation-card ul {
            list-style: none;
            padding: 0;
        }
        
        .recommendation-card li {
            margin-bottom: 2px;
            padding-left: 8px;
            position: relative;
            font-size: 9px;
        }
        
        .recommendation-card li:before {
            content: "•";
            position: absolute;
            left: 0;
        }
        
        .warning-section {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 15px;
            margin-bottom: 12px;
        }
        
        .warnings, .vet-recommendation {
            padding: 8px;
            border-radius: 6px;
        }
        
        .warnings {
            background: #fef3c7;
            border-left: 4px solid #f59e0b;
        }
        
        .vet-recommendation {
            background: #fdf2f8;
            border-left: 4px solid #ec4899;
        }
        
        .warnings h4, .vet-recommendation h4 {
            font-size: 10px;
            font-weight: 600;
            margin-bottom: 5px;
            display: flex;
            align-items: center;
        }
        
        .warnings ul, .vet-recommendation ul {
            list-style: none;
            padding: 0;
            font-size: 9px;
        }
        
        .warnings li, .vet-recommendation li {
            margin-bottom: 2px;
            padding-left: 12px;
            position: relative;
        }
        
        .warnings li:before {
            content: "⚠";
            color: #f59e0b;
            position: absolute;
            left: 0;
        }
        
        .vet-recommendation li:before {
            content: "📋";
            position: absolute;
            left: 0;
        }
        
        .notes-section {
            background: #f9fafb;
            border: 1px solid #e5e7eb;
            border-radius: 6px;
            padding: 8px;
            margin-bottom: 12px;
        }
        
        .notes-section h4 {
            font-size: 10px;
            font-weight: 600;
            color: #374151;
            margin-bottom: 5px;
        }
        
        .action-buttons {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr 1fr;
            gap: 8px;
            margin-top: 10px;
        }
        
        .action-btn {
            padding: 8px 12px;
            border: none;
            border-radius: 6px;
            font-size: 9px;
            font-weight: 600;
            text-align: center;
            cursor: pointer;
        }
        
        .btn-primary {
            background: #3b82f6;
            color: white;
        }
        
        .btn-secondary {
            background: #8b5cf6;
            color: white;
        }
        
        .btn-success {
            background: #10b981;
            color: white;
        }
        
        .btn-warning {
            background: #f59e0b;
            color: white;
        }
        
        .icon {
            display: inline-block;
            width: 12px;
            height: 12px;
            margin-right: 4px;
        }
        
        @media print {
            .container {
                height: auto;
                box-shadow: none;
            }
            
            .action-buttons {
                display: none;
            }
        }
    </style>
</head>
<body>
    <div class="container">
        <!-- Header -->
        <div class="header">
            <h1>VetSense AI Health Analysis</h1>
            <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 8px;">
                <div class="priority-badge ${
                  checkUp.status === "completed"
                    ? "low-priority"
                    : checkUp.status === "in-progress"
                    ? "medium-priority"
                    : "high-priority"
                }">
                    ${
                      checkUp.status === "completed"
                        ? "Low Priority"
                        : checkUp.status === "in-progress"
                        ? "Medium Priority"
                        : "High Priority"
                    }
                </div>
                <div class="confidence">
                    Confidence level: ${
                      checkUp.diagnosis?.confidence || "moderate"
                    }
                </div>
            </div>
        </div>

        <!-- Pet Information -->
        <div class="pet-info">
            <div>
                <strong>Name:</strong>
                <span>${checkUp.pet?.name || "Kala Fata Kutta"}</span>
            </div>
            <div>
                <strong>Age:</strong>
                <span>${checkUp.pet?.age || "12 years old"}</span>
            </div>
            <div>
                <strong>Sex:</strong>
                <span>${checkUp.pet?.gender || "male"}</span>
            </div>
            <div>
                <strong>Species:</strong>
                <span>${checkUp.pet?.species || "Dog"}</span>
            </div>
            <div>
                <strong>Breed:</strong>
                <span>${
                  checkUp.pet?.breed || "Indian Desi (Non Descript)"
                }</span>
            </div>
        </div>

        <!-- Symptoms Section -->
        <div class="symptoms-section">
            <h3><div class="checkbox"></div> Summary of symptoms</h3>
            <p style="font-size: 10px; margin-top: 3px;">
                ${
                  checkUp.chiefComplaint ||
                  "No specific symptoms reported. General health assessment completed."
                }
            </p>
        </div>

        <!-- Overall Assessment -->
        <div class="assessment-section">
            <h3>Overall Assessment:</h3>
            <p style="font-size: 10px; line-height: 1.4;">
                ${
                  checkUp.diagnosis?.primary
                    ? `${checkUp.pet?.name || "Pet"}'s condition (${
                        checkUp.diagnosis.primary
                      }) requires attention. ${
                        checkUp.diagnosis.notes ||
                        "Complete assessment and treatment plan have been developed. Immediate veterinary attention is recommended."
                      }`
                    : `${
                        checkUp.pet?.name || "Pet"
                      }'s current weight and vital signs indicate need for evaluation. The lack of comprehensive health information makes a complete assessment challenging. Immediate veterinary attention is recommended for proper diagnosis and treatment planning.`
                }
            </p>
        </div>

        <!-- Key Findings -->
        <div class="key-findings">
            <h4><span class="icon">🔍</span> Key Findings:</h4>
            <ul>
                ${
                  checkUp.vitalSigns?.weight
                    ? `<li>Current weight recorded: ${checkUp.vitalSigns.weight}kg</li>`
                    : `<li>Weight assessment needed for baseline health monitoring</li>`
                }
                ${
                  checkUp.chiefComplaint
                    ? `<li>Primary concern: ${checkUp.chiefComplaint}</li>`
                    : `<li>Missing crucial health information</li>`
                }
                ${
                  checkUp.pet?.age
                    ? `<li>Advanced age (${checkUp.pet.age}) requires special consideration</li>`
                    : `<li>Age-specific health monitoring required</li>`
                }
            </ul>
        </div>

        <!-- Recommendations Grid -->
        <div class="recommendations-grid">
            <!-- Immediate -->
            <div class="recommendation-card immediate">
                <h4><span class="icon">⚠</span> Immediate:</h4>
                <ul>
                    <li>Schedule veterinary consultation immediately</li>
                    <li>${
                      checkUp.prescription?.length > 0
                        ? "Begin prescribed medication regimen"
                        : "Comprehensive health examination"
                    }</li>
                    <li>${
                      checkUp.vitalSigns
                        ? "Monitor vital signs daily"
                        : "Record baseline vital signs and weight"
                    }</li>
                </ul>
            </div>

            <!-- Short-term -->
            <div class="recommendation-card short-term">
                <h4><span class="icon">📋</span> Short-term:</h4>
                <ul>
                    <li>Follow veterinarian's treatment plan</li>
                    <li>${
                      checkUp.followUpInstructions
                        ? "Implement follow-up care instructions"
                        : "Monitor weight and behavioral changes"
                    }</li>
                    <li>Schedule follow-up appointment</li>
                </ul>
            </div>

            <!-- Long-term -->
            <div class="recommendation-card long-term">
                <h4><span class="icon">🎯</span> Long-term:</h4>
                <ul>
                    <li>Regular veterinary check-ups</li>
                    <li>${
                      checkUp.pet?.age && parseInt(checkUp.pet.age) > 8
                        ? "Senior pet care management"
                        : "Preventive health monitoring"
                    }</li>
                    <li>Maintain health records and vaccination schedule</li>
                </ul>
            </div>
        </div>

        <!-- Warning Signs and Vet Recommendation -->
        <div class="warning-section">
            <div class="warnings">
                <h4><span class="icon">⚠</span> Warning Signs:</h4>
                <ul>
                    <li>${
                      checkUp.chiefComplaint
                        ? "Monitor primary symptoms for changes"
                        : "Watch for lethargy or loss of appetite"
                    }</li>
                    <li>${
                      checkUp.vitalSigns?.temperature
                        ? "Temperature fluctuations"
                        : "Changes in breathing patterns"
                    }</li>
                    <li>Difficulty eating or drinking</li>
                    <li>Changes in urination or bowel movements</li>
                </ul>
            </div>

            <div class="vet-recommendation">
                <h4><span class="icon">🏥</span> Vet Recommendation:</h4>
                <ul>
                    <li style="background: #fce7f3; padding: 4px; border-radius: 3px; margin-bottom: 4px;">
                        ${
                          checkUp.status === "completed"
                            ? "Continue prescribed treatment plan"
                            : "Seek immediate veterinary attention"
                        }
                    </li>
                </ul>
            </div>
        </div>

        <!-- Additional Notes -->
        <div class="notes-section">
            <h4><span class="icon">📝</span> Additional Notes:</h4>
            <p style="font-size: 9px; line-height: 1.3;">
                ${
                  checkUp.diagnosis?.notes ||
                  `This analysis is based on available health data. A thorough veterinary examination is strongly recommended to determine the underlying cause and establish appropriate treatment. Regular health monitoring is essential for ${
                    checkUp.pet?.name || "your pet"
                  }'s overall well-being.`
                }
            </p>
        </div>

        <!-- Action Buttons -->
        <div class="action-buttons">
            <button class="action-btn btn-primary">
                <span class="icon">🔄</span> New Check-up
            </button>
            <button class="action-btn btn-secondary">
                <span class="icon">🧠</span> Re-analyse with VetSense AI
            </button>
            <button class="action-btn btn-success">
                <span class="icon">🖨</span> Print Result
            </button>
            <button class="action-btn btn-warning">
                <span class="icon">📅</span> Book Appointment for ${
                  checkUp.pet?.name || "Pet"
                }
            </button>
        </div>
    </div>
</body>
</html>`;
  };

  // Handle download AI analysis
  const handleDownloadAIAnalysis = () => {
    try {
      const htmlContent = generateAIAnalysisHTML();

      // Create a new window/tab
      const printWindow = window.open("", "_blank");

      if (!printWindow) {
        alert(
          "Please allow popups for this website to download the AI analysis."
        );
        return;
      }

      // Write the HTML content to the new window
      printWindow.document.write(htmlContent);
      printWindow.document.close();

      // Wait for content to load, then trigger print dialog
      printWindow.onload = () => {
        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
        }, 500);
      };

      console.log("AI Analysis generated successfully for:", checkUp.pet?.name);
    } catch (error) {
      console.error("Error generating AI analysis:", error);
      alert("Failed to generate AI analysis. Please try again.");
    }
  };

  // Handle view prescription (opens in new tab without printing)
  const handleViewPrescription = () => {
    try {
      const htmlContent = generatePrescriptionHTML();
      const viewWindow = window.open("", "_blank");

      if (!viewWindow) {
        alert("Please allow popups for this website to view the prescription.");
        return;
      }

      viewWindow.document.write(htmlContent);
      viewWindow.document.close();
      viewWindow.focus();
    } catch (error) {
      console.error("Error viewing prescription:", error);
      alert("Failed to view prescription. Please try again.");
    }
  };

  // Handle view AI analysis
  const handleViewAIAnalysis = () => {
    try {
      const htmlContent = generateAIAnalysisHTML();
      const viewWindow = window.open("", "_blank");

      if (!viewWindow) {
        alert("Please allow popups for this website to view the AI analysis.");
        return;
      }

      viewWindow.document.write(htmlContent);
      viewWindow.document.close();
      viewWindow.focus();
    } catch (error) {
      console.error("Error viewing AI analysis:", error);
      alert("Failed to view AI analysis. Please try again.");
    }
  };

  return {
    downloadPrescription: handleDownloadPrescription,
    viewPrescription: handleViewPrescription,
    downloadAIAnalysis: handleDownloadAIAnalysis,
    viewAIAnalysis: handleViewAIAnalysis,
  };
};

export default PrescriptionDownload;
